import React, { useState } from "react";
import { trackError } from "../../../../lib/metrics";

export default function AnimalIconCodeLock({
  expectedCode = "8611",
  onUnlock,
  errorText = "⛔ Code incorrect.",
  sessionCode,
  stage,
  playerId,
}) {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const trimmed = (code || "").trim();

    if (trimmed === expectedCode) {
      setErr("");
      onUnlock?.();
      return;
    }

    setErr(errorText);
    // ── trackError ──
    trackError({
      sessionCode,
      stage,
      playerId,
      reason: "animal_icon_code_lock_wrong_code",
      meta: { entered: trimmed },
    });
  };

  return (
    <div className="space-y-4">
      <div className="
        relative
        rounded-2xl
        p-3
        border border-white/15
        bg-slate-300
        shadow-[0_0_25px_rgba(99,102,241,0.25)]
      ">
        <div className="relative grid grid-cols-4 gap-3 place-items-center">
          <img src="/assets/cat.png" alt="Chat" className="h-12 w-12 object-contain" draggable={false} />
          <img src="/assets/dog.png" alt="Chien" className="h-12 w-12 object-contain" draggable={false} />
          <img src="/assets/spider.png" alt="Araignée" className="h-12 w-12 object-contain" draggable={false} />
          <img src="/assets/hamster.png" alt="Hamster" className="h-12 w-12 object-contain" draggable={false} />
        </div>
      </div>

      <form onSubmit={submit} className="rounded-2xl border border-white/10 bg-black/35 p-3">
        <label className="block text-[11px] uppercase tracking-[0.18em] text-slate-400">
          Code du tiroir
        </label>

        <div className="mt-2 flex gap-2">
          <input
            value={code}
            onChange={(e) => {
              setCode(e.target.value.replace(/[^0-9]/g, ""));
              setErr("");
            }}
            maxLength={4}
            inputMode="numeric"
            className="flex-1 px-3 py-2 rounded-xl bg-black/60 border border-white/15 text-sm text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 font-mono tracking-[0.25em]"
            placeholder="____"
          />
          <button
            type="submit"
            className="px-4 py-2 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-xs font-semibold transition"
          >
            Valider
          </button>
        </div>

        {err ? <p className="mt-2 text-[11px] text-rose-200">{err}</p> : null}
      </form>
    </div>
  );
}